/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HistoryBulkSaveDto } from '../../models/history-bulk-save-dto';

export interface HistoryAdminControllerBulkSaveV1$Params {
      body: HistoryBulkSaveDto
}

export function historyAdminControllerBulkSaveV1(http: HttpClient, rootUrl: string, params: HistoryAdminControllerBulkSaveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, historyAdminControllerBulkSaveV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

historyAdminControllerBulkSaveV1.PATH = '/api/v1/histories/admin/bulk-save';
